/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["google-docs-viewer{display:block;width:100%;height:100%;margin:auto;position:absolute;top:0;left:0;right:0;bottom:0}google-docs-viewer iframe{width:100%;height:100%;border:none}google-docs-viewer loading-indicator.overlay{position:absolute;width:100%;height:100%;background-color:transparent}google-docs-viewer default-preview{margin:auto;position:absolute;top:0;left:0;right:0;bottom:0}google-docs-viewer .pop-out-block{width:40px;height:40px;position:absolute;top:12px;right:12px;cursor:pointer}"];
export { styles as styles };
